import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=bc06d982&scoped=true&"
import script from "./questionnaire.vue?vue&type=script&lang=js&"
export * from "./questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./questionnaire.vue?vue&type=style&index=0&lang=css&"
import style1 from "./questionnaire.vue?vue&type=style&index=1&id=bc06d982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc06d982",
  null
  
)

export default component.exports